import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';

import { PartnerService } from '../../../shared/services/partner.service';
import { StateService } from '../../../products/services/state.service';
import { UserService } from '../../../shared/services/user.service';

@Component({
  selector: 'app-hidden-login',
  standalone: true,
  imports: [ReactiveFormsModule, RouterModule],
  templateUrl: './hidden-login.component.html',
  styleUrl: './hidden-login.component.scss'
})
export class HiddenLoginComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private formBuilder = inject(FormBuilder);
  private userService = inject(UserService);
  private partnerService = inject(PartnerService);

  form = this.formBuilder.group({
    username: ['', Validators.required],
    password: ['', Validators.required]
  });

  readonly maintenanceModel = inject(StateService).maintenanceModel;
  loading = false;
  loginError?: string;

  ngOnInit(): void {
    if (this.userService.isAuthenticated()) {
      if (this.userService.isAdmin()) {
        window.location.replace('/Admin');
      }
      else {
        this.router.navigate(['/dashboard']);
      }
    }

    this.route.url.subscribe(params => {
      const partnerCode = params[1]?.path;
      if (partnerCode != undefined) {
        this.partnerService.setPartner(partnerCode);
      }
    });
  }

  onLogin() {
    this.loading = true;
    this.loginError = undefined;
    this.userService.login(this.form.value.username!, this.form.value.password!)
      .subscribe({
        error: () => {
          this.loading = false;
          this.loginError = 'Email or password is invalid';
        }
      });
  }
}
